<div class="edit-page__scrollable-content" #scrollableContent (scroll)="onScroll()">
  @for (section of visibleTabs(); track section.key) {
    <div [id]="section.key" class="edit-page__section" #sectionElement>
      <h2 class="edit-page__section-title">
        {{ section.label | translate }}
      </h2>

      <div class="edit-page__section-content">
        @switch (section.key) {
          @case (SECTIONS.general) {
            <app-product-general-info
              [item]="item()"
              [isEditable]="true"
              [showPrice]="false"
              [productDescriptionRows]="5"
              [form]="form()"
            />
          }
          @case (SECTIONS.price) {
            <app-product-price-section [item]="item()" [parentForm]="form()" />
          }
          @case (SECTIONS.availability) {
            <app-product-availability-section [item]="item()" [parentForm]="form()" />
          }
          @case (SECTIONS.media) {
            <!-- TODO: add media section -->
          }
          @case (SECTIONS.productDetails) {
            <app-product-details-section
              [currentDetails]="item().productDetails"
              [detailsFormArray]="productDetailsComputed()"
              [itemId]="item().id"
            />
          }
          @case (SECTIONS.variants) {
            <!-- TODO: add variants section -->
          }
        }
      </div>
    </div>
  }
</div>
